import React from 'react';

import { LeadModel } from '@/typings/models/Lead';

import classNames from 'classnames';

import styles from './index.less';
import EditableTextField from '@/components/Lead/EditableTextField';
import { F } from '@/utils/intl';

const LeadDealSize = ({ lead, isTable, readonly }: { lead: LeadModel; isTable?: boolean; readonly?: boolean }) => {
  return (
    <EditableTextField lead={lead} property={'order_volume'} isTable={isTable} editable={!readonly}>
      {lead?.order_volume ? (
        <div className={styles.leadDealSize}>
          {`${lead?.order_volume}`.replace(/\d(?=(\d{3})+$)/g, '$&.')}
        </div>
      ) : (
        <div className={classNames(styles.leadDealSize, styles.leadDealSizePlaceholder)}>
          <F id={'pages.lead.fields.dealSize'} defaultMessage={'Deal Size'} />
        </div>
      )}
    </EditableTextField>
  );
};

export default LeadDealSize
